import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { productsApi } from './Reducer/products';
import { authApi } from './Reducer/auth';
import userReducer from './slices/userSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { usersApi } from './Reducer/users';
import { FaqsApi } from './Reducer/faqs';
import { adminSettingsApi } from './Reducer/adminSetting';
import { adminSupportApi } from './Reducer/adminSupport';
import { contactApi } from './Reducer/contact';
import { customersApi } from './Reducer/customers';
import { languageApi } from './Reducer/languages';
import { dashboardApi } from './Reducer/dashboard';
import { fileApi } from './Reducer/file';
import { categoriesApi } from './Reducer/categories';
import { levelsApi } from './Reducer/levels';

// Define the persist configuration
const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['user'],
};

// Create a persisted reducer for the user slice
const persistedUserReducer = persistReducer(persistConfig, userReducer);

// Create the Redux store with the persisted reducer for the user slice
export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [customersApi.reducerPath]: customersApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [FaqsApi.reducerPath]: FaqsApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
    [adminSettingsApi.reducerPath]: adminSettingsApi.reducer,
    [adminSupportApi.reducerPath]: adminSupportApi.reducer,
    [languageApi.reducerPath]: languageApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [categoriesApi.reducerPath]: categoriesApi.reducer,
    [levelsApi.reducerPath]: levelsApi.reducer,
    user: persistedUserReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
      },
    }).concat(
      // productsApi.middleware,
      FaqsApi.middleware,
      contactApi.middleware,
      customersApi.middleware,
      adminSettingsApi.middleware,
      adminSupportApi.middleware,
      usersApi.middleware,
      languageApi.middleware,
      dashboardApi.middleware,
      authApi.middleware,
      fileApi.middleware,
      categoriesApi.middleware,
      levelsApi.middleware
    ),
});

// Initialize Redux Persist
export const persistor = persistStore(store);

// Setup listeners
setupListeners(store.dispatch);
